import { useTranslation } from 'next-i18next';
import React, { FC, useCallback } from 'react';
import PageMeta from 'src/components/organisms/page-meta';
import { ExploreTopFiltersContainer } from 'src/features/common/explore/containers/explore-top-filters-container';
import { NftsExploreContainer } from 'src/features/common/explore/containers/nfts-explore-container';
import { ExploreContentLayout } from 'src/features/white-labels/ocean/explore/components/explore-content-layout';
import { ExploreHeader } from 'src/features/white-labels/ocean/explore/components/explore-header';
import { FilterButton } from 'src/features/white-labels/ocean/explore/components/filter-button';
import { ExploreFilterContainer } from 'src/features/white-labels/ocean/explore/containers/explore-filter-container';
import { EmptyListPlaceholder } from 'src/features/white-labels/ocean/shared/components/empty-list-placeholder';
import { Spacing } from 'src/ui/common/atoms/spacing';
import { Typography } from 'src/ui/common/atoms/typography';
import { ITabItem } from 'src/ui/common/molecules/tabs/tabs.types';
import { SimpleTabs } from 'src/ui/white-labels/ocean/molecules/simple-tabs';
import { Tabs } from 'src/ui/white-labels/ocean/molecules/tabs';

interface IProps {
    title: string;
    description: string;
    sideBarOpened: boolean;
    toggleSideBar: () => void;
    isFiltersApplied: boolean;
    clearFilters: () => void;
    tabItems: ITabItem[];
    emptyList: { title: string; description: string };
}

export const ExplorePageWhiteLabel: FC<IProps> = ({
    title,
    description,
    sideBarOpened,
    toggleSideBar,
    isFiltersApplied,
    clearFilters,
    tabItems,
    emptyList,
}) => {
    const { t } = useTranslation(['pages', 'components']);
    const emptyPlaceholder = useCallback(
        ({ itemsGridConfig }) => (
            <EmptyListPlaceholder itemsGridConfig={itemsGridConfig}>
                <Typography size="base" tag="div" variant="text" color="gs400">
                    {emptyList.title}
                </Typography>
                <Spacing margin="10px 0 30px">
                    <Typography size="sm" tag="div" color="gs200">
                        <span dangerouslySetInnerHTML={{ __html: emptyList.description }} />
                    </Typography>
                </Spacing>
            </EmptyListPlaceholder>
        ),
        [emptyList]
    );

    return (
        <>
            <PageMeta title={title} description={description} />
            <ExploreHeader title={t('explore.title', { ns: 'pages' })} />
            <SimpleTabs initialTabId="items">
                <ExploreContentLayout>
                    <ExploreContentLayout.TopPanel>
                        <FilterButton
                            opened={sideBarOpened}
                            onToggle={toggleSideBar}
                            showClearBtn={isFiltersApplied}
                            onClear={clearFilters}
                        />
                        <Tabs.TabItems tabItems={tabItems} />
                    </ExploreContentLayout.TopPanel>
                    <ExploreContentLayout.Content>
                        <ExploreContentLayout.SideBar opened={sideBarOpened}>
                            <ExploreFilterContainer />
                        </ExploreContentLayout.SideBar>
                        <ExploreContentLayout.ExploreContent>
                            <SimpleTabs.Content tabId="items">
                                <ExploreTopFiltersContainer />
                                <NftsExploreContainer
                                    sideBarOpened={sideBarOpened}
                                    emptyPlaceholder={emptyPlaceholder}
                                />
                            </SimpleTabs.Content>
                        </ExploreContentLayout.ExploreContent>
                    </ExploreContentLayout.Content>
                </ExploreContentLayout>
            </SimpleTabs>
        </>
    );
};
